import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import DeleteIcon from '@material-ui/icons/Delete'
import SaveIcon from '@material-ui/icons/SaveAlt'
import FilterListIcon from '@material-ui/icons/FilterList'
import { lighten } from '@material-ui/core/styles/colorManipulator'
import Button from '@material-ui/core/Button'

import moment from 'moment'
import NumberFormat from 'react-number-format'
import { substitute } from '../../utility/utilities'
import config from '../../config'

const headRows = [
    { id: 'description', numeric: false, disablePadding: false, label: 'Description' },
    { id: 'date', numeric: false, disablePadding: false, label: 'Date' },
    { id: 'amount', numeric: false, disablePadding: false, label: 'Amount' },
    { id: 'status', numeric: false, disablePadding: false, label: 'Status' },
    { id: 'actions', numeric: false, disablePadding: false, label: 'Actions' },
]

function EnhancedTableHead(props) {
    const classes = useStyles()

    return (
        <TableHead>
            <TableRow>
            { headRows.map(row => (
                <TableCell
                    key={row.id}
                    align={row.numeric ? 'right' : 'left'}
                    padding={row.disablePadding ? 'none' : 'default'}
                    className={ classes.table_header_cell }
                >
                    {row.label}
                </TableCell>
            ))}
            </TableRow>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    rowCount: PropTypes.number.isRequired,
}

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        boxShadow: 'none',
    },
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    row: {
        paddingTop: 2,
        paddingBottom: 2,
    },
    icon: {
        fontSize: 16,
    },
    buttonPadding: {
        padding: 6,
    },
    table_header_cell: {
        fontWeight: 500,
        fontSize: 12,
        paddingLeft: 1,
        '&:last-child': {
            paddingRight: 1,
        },
        color: 'rgba(0, 0, 0, 0.7)',
    },
    table_cell: {
        paddingTop: 3,
        paddingBottom: 3,
        paddingLeft: 1,
        '&:last-child': {
            paddingRight: 1,
        },
        color: 'rgba(0, 0, 0, 0.7)',
    },
}))

function DocumentsTable(props) {

    const { billingData, billingloading, member_id } = props

    const classes = useStyles()
    const [page, setPage] = React.useState(0)
    const [rowsPerPage, setRowsPerPage] = React.useState(25)

    function handleChangePage(event, newPage) {
        setPage(newPage);
    }

    function handleChangeRowsPerPage(event) {
        setRowsPerPage(+event.target.value);
    }

    function getBillingDownloadURL(id) {
        const invoiceDowload = substitute(config.endpoints.billingDownloadURL, {member_id: member_id, id: id})
        return invoiceDowload
    }

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, billingData.length - page * rowsPerPage);
    
    return (
        <div className={classes.root}>

            { !billingloading && billingData.length === 0 &&
                <Typography>
                    Fund has no billing history
                </Typography>
            }

            { billingData.length > 0 &&
                <Paper className={classes.paper}>
                    <div className={classes.tableWrapper}>
                        <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size="small"
                        >
                            <EnhancedTableHead
                                rowCount={billingData.length}
                            />
                            <TableBody>
                                { billingData.map((row, index) => {

                                    return (
                                        <TableRow hover tabIndex={-1} key={index}>
                                            <TableCell className={ classes.table_cell }>Selfmade Direct Debit</TableCell>
                                            <TableCell className={ classes.table_cell }>{moment(row.debit_date).format("MMMM DD, YYYY, HH:MM A")}</TableCell>
                                            <TableCell className={ classes.table_cell }><NumberFormat value={row.payment_amount} displayType={'text'} thousandSeparator={true} prefix={'$'} /></TableCell>
                                            { row.payment_status === "S" &&
                                                <TableCell className={ classes.table_cell } scope="row">Successful</TableCell>
                                            }
                                            { row.payment_status === "P" &&
                                                <TableCell className={ classes.table_cell } scope="row">Pending</TableCell>
                                            }
                                            { row.payment_status === "W" &&
                                                <TableCell className={ classes.table_cell } scope="row">Waiting</TableCell>
                                            }
                                            { (row.payment_status === "D" || row.payment_status === "F")  &&
                                                <TableCell className={ classes.table_cell } scope="row">Fail</TableCell>
                                            }
                                            <TableCell className={ classes.table_cell }>
                                                <Tooltip className={ classes.buttonPadding } title="Download">
                                                    <IconButton aria-label="Download" target="_blank" href={getBillingDownloadURL(index)}>
                                                        <SaveIcon className={ classes.icon } />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                                {/*emptyRows > 0 && (
                                    <TableRow style={{ height: 49 * emptyRows }}>
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )*/}
                            </TableBody>
                        </Table>
                    </div>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={billingData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        backIconButtonProps={{
                        'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                        'aria-label': 'Next Page',
                        }}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                </Paper>
            }
            {/*
            <Button component="span" className={classes.button}>
                Upload a document
            </Button>
            */}
        </div>
    )
}

export default DocumentsTable;


// WEBPACK FOOTER //
// ./src/components/BillingTable/index.js